import './offerCard.css';
import { useState } from 'preact/hooks';
import Button from '@thesavingsgroup/components/Button/Button';
import Anchor from '@thesavingsgroup/components/Anchor/Anchor';

type OfferCardProps = {
  apr?: string;
  brand: string;
  disclaimer: string;
  loanAmount?: string;
  logo: string;
  payment?: string;
  redirectURL: string;
  term?: string;
  onViewDetailsClick?: () => void;
};

const applyAtStrings: Record<string, string> = {
  autopay: 'on autopay.com',
  rateGenius: 'on rategenius.com',
  tresl: 'on mytresl.com',
};

const OfferCard = ({
  apr,
  brand,
  disclaimer,
  loanAmount,
  logo,
  payment,
  redirectURL,
  term,
  onViewDetailsClick,
}: OfferCardProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  const handleExpand = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div class="offer-card">
      <div class="content">
        <div class="logo-section">
          <Anchor
            href={redirectURL}
            target="_blank"
            onClick={onViewDetailsClick}
          >
            <img src={logo} alt="Offer Image" />
          </Anchor>
        </div>

        <div class="divider"></div>

        <div class="details-section">
          {payment && (
            <div>
              <span>Est. Payment*</span>
              <span>{payment}</span>
            </div>
          )}
          {apr && (
            <div>
              <span>Est. Apr*</span>
              <span>{apr}</span>
            </div>
          )}
          {loanAmount && (
            <div>
              <span>Loan amount</span>
              <span>{loanAmount}</span>
            </div>
          )}
          {term && (
            <div>
              <span>Term</span>
              <span>{term}</span>
            </div>
          )}
        </div>

        <div class="divider"></div>

        <div class="actions-section">
          <Anchor
            href={redirectURL}
            target="_blank"
            onClick={onViewDetailsClick}
            fullWidth
          >
            View details
          </Anchor>

          <label>{applyAtStrings[brand]}</label>

          <Button onClick={handleExpand} textOnly>
            Offer terms
          </Button>
        </div>
      </div>

      {isExpanded && <p>{disclaimer}</p>}
    </div>
  );
};

export default OfferCard;
